import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icons-chat",
  "use": "icons-chat-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"icons-chat\"><polygon fill=\"currentColor\" points=\"21 5 21 18 10.67 18 6 21.5 6 18 3 18 3 5 21 5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol